import { ICropperOptions } from './common';

export const SALONS_DEFAULT_MAX_DISTANCE = 10000;

export const NODE_TYPE_LIKEDPRODUCT_ITEM = 'LikedProductItem';
export const NODE_TYPE_OUTFIT_ITEM = 'OutfitItem';
export const NODE_TYPE_SUGGESTION_ITEM = 'SuggestionItem';
export const NODE_TYPE_WHO_TO_FOLLOW_ITEM = 'WhoToFollowItem';

export const MIN_TIME_INTERVAL_MINUTES = 5;
export const SPLIT_TIME_INTERVAL_MINUTES = 30;

/* item card names */
export const NODE_TYPE_ADMIN_ARTICLE_ITEM_CARD = 'AdminArticleItemCard';
export const NODE_TYPE_ADMIN_MENU_ITEM_CARD = 'AdminMenuItemCard';
export const NODE_TYPE_ADMIN_POLL_ITEM_CARD = 'AdminPollItemCard';
export const NODE_TYPE_ARTICLE_ITEM_CARD = 'ArticleItemCard';
export const NODE_TYPE_ARTICLE_TAG_ITEM_CARD = 'AdminTagItemCard';
export const NODE_TYPE_MAGAZINE_ARTICLE_ITEM_CARD = 'MagazineArticleItemCard';
export const NODE_TYPE_MAGAZINE_ARTICLE_ITEM_SMALL_CARD = 'MagazineArticleItemSmallCard';
export const NODE_TYPE_OUTFIT_ITEM_CARD = 'OutfitItemCard';
export const NODE_TYPE_OUTFIT_ITEM_SMALL_CARD = 'OutfitItemSmallItemCard';
export const NODE_TYPE_SIMILAR_ARTICLE_DESKTOP_ITEM_CARD = 'SimilarArticleDesktopItemCard';
export const NODE_TYPE_SELECTOR_ITEM_CARD = 'SelectorItemCard';
export const NODE_TYPE_USER_ITEM_CARD = 'UserItemCard';
export const NODE_TYPE_SHOP_ITEM_CARD = 'ShopItemCard';
export const NODE_TYPE_OFFICE_ITEM_CARD = 'OfficeItemCard';
export const NODE_TYPE_FOLLOWER_FOLLOWING_ITEM_CARD = 'FollowerFollowingItemCard';
export const NODE_TYPE_USER_PAYMENT_METHOD_CARD = 'UserPaymentMethodItemCard';
export const NODE_TYPE_USER_SHIPPING_ADDRESS_CARD = 'UserShippingAddressItemCard';
export const NODE_TYPE_PRODUCT_ITEM_CARD = 'ProductItemCard';
export const NODE_TYPE_WARDROBE_ITEM_CARD = 'WardrobeItemCard';
export const NODE_TYPE_ONBOARDING_QUIZ_FOLLOW_CARD = 'OnboardingQuizFollowItemCard';
export const NODE_TYPE_USER_RECENT_ACTIVITY_CARD = 'UserRecentActivityItemCard';
export const NODE_TYPE_USER_LIKE_CARD = 'UserLikeCard';
export const NODE_TYPE_COMMENT_CARD = 'CommentItemCard';
export const NODE_TYPE_USERORDER_ITEM_CARD = 'OrderItemCard';
export const NODE_TYPE_ORDERCARD_ITEM_CARD = 'OrderCardItemCard';
export const NODE_TYPE_SHOPDASHBOARD_ORDER_ITEM_CARD = 'ShopDashboardOrderItemCard';
export const NODE_TYPE_SHOPDASHBOARD_PRODUCT_ITEM_CARD = 'ShopDashboardProductItemCard';
export const NODE_TYPE_SHOPPINGBAG_ITEM_CARD = 'ShoppingBagProductItemCard';
export const NODE_TYPE_SHOPPINGBAG_REMOVED_ITEM_CARD = 'ShoppingBagRemovedProductCard';
export const NODE_TYPE_CHECKOUTPRODUCT_ITEM_CARD = 'CheckoutProductItemCard';
export const NODE_TYPE_STAFFPREVIEW_ITEM_CARD = 'StaffPreviewItemCard';
export const NODE_TYPE_ADMIN_SHOP_REVIEW_ITEM_CARD = 'AdminShopReviewItemCard';
export const NODE_TYPE_NOTIFICATION_ITEM_CARD = 'NotificationItemCard';
export const NODE_TYPE_ADMIN_SHOP_ITEM_CARD = 'AdminShopItemCard';
export const NODE_TYPE_CUSTOMER_ITEM_CARD = 'CustomerItemCard';

/* node types */
export const NODE_TYPE_ARTICLE = 'Article';
export const NODE_TYPE_PRODUCT = 'Product';
export const NODE_TYPE_SHOP = 'Shop';
export const NODE_TYPE_USER = 'User';
export const NODE_TYPE_WARDROBE = 'WardrobeItem';
export const NODE_TYPE_OUTFIT = 'Outfit';
export const NODE_TYPE_WISHLIST = 'Wishlist';
export const NODE_TYPE_JOB = 'JOB';

/* search suggestion types */
export const SEARCH_SUGGESTION_TYPE_ARTICLE = 'Article';
export const SEARCH_SUGGESTION_TYPE_USER = 'User';
export const SEARCH_SUGGESTION_TYPE_CATEGORY = 'Category';
export const SEARCH_SUGGESTION_TYPE_PRODUCT = 'Product';

/* various data */
export const MAX_IMAGE_SIZE = 4194304;
export const MAX_PRODUCT_IMAGE_SIZE = 409600;

/* form names */
export const FORM_NAME_ADD_CUSTOMER = 'addcustomer';
export const FORM_NAME_ADD_IMAGE = 'addimage';
export const FORM_NAME_ADD_MAGAZINE_MENU_ITEMS = 'addmagazinemenuitems';
export const FORM_NAME_ADD_SERVICE = 'addservice';
export const FORM_NAME_CONNECTED_SERVICES = 'connectedservices';
export const FORM_NAME_SELECT_SERVICE = 'selectservice';
export const FORM_NAME_CREATE_PRODUCT = 'createproduct';
export const FORM_NAME_EDIT_PRODUCT = 'editproduct';
export const FORM_NAME_MANAGE_ARTICLE = 'managearticle';
export const FORM_NAME_MANAGE_ARTICLESETTINGS = 'managearticlesettings';
export const FORM_NAME_MANAGE_ARTICLE_CATEGORY = 'managearticlecategory';
export const FORM_NAME_EDIT_ARTICLE_COMMENT = 'editarticlecomment';
export const FORM_NAME_EDIT_ARTICLE_TAG = 'editarticletag';
export const FORM_NAME_MANAGE_MENU_ITEM = 'managemenuitem';
export const FORM_NAME_MANAGE_POLL = 'managepoll';
export const FORM_NAME_CREATE_WARDROBEITEM = 'createwardrobeitem';
export const FORM_NAME_EDIT_WARDROBEITEM = 'editwardrobeitem';
export const FORM_NAME_USERPROFILE = 'userprofile';
export const FORM_NAME_CUSTOMERPROFILE = 'customerprofile';
export const FORM_NAME_SET_DEFAULT_PAYMENT_METHOD = 'setdefaultpaymentmethod';
export const FORM_NAME_SHOPPROFILE = 'shopprofile';
export const FORM_NAME_MANAGEOUTFIT = 'manageoutfit';
export const FORM_NAME_USERPREFERENCES = 'userpreferences';
export const FORM_NAME_MANAGE_ICO_ORDER = 'manageicoorder';
export const FORM_NAME_CLAIM_TRANSACTION = 'claimtransaction';
export const FORM_NAME_MANAGE_SHOP = 'manageshop';
export const FORM_NAME_CREATE_SHOP = 'createshop';
export const FORM_NAME_MANAGE_OFFICE_STAFF_MEMBER = 'manageofficestaffmember';
export const FORM_NAME_MANAGE_SHOP_SHIPPING_OPTION = 'manageshopshippingoption';
export const FORM_NAME_MANAGE_USER_SHIPPING_ADDRESS = 'manageusershippingaddress';
export const FORM_NAME_ONBOARDING_QUIZ = 'onboardingquiz';
export const FORM_NAME_ADD_COMMENT = 'addcomment';
export const FORM_NAME_CART = 'cart';
export const FORM_NAME_HELP_CENTER_CONTACT = 'helpcentercontactform';
export const FORM_NAME_NOTIFICATION_SETTINGS = 'notificationsettings';
export const FORM_NAME_ORDER_SHIPPING = 'ordershipping';
export const FORM_NAME_ABOUT = 'about';
export const FORM_NAME_CUSTOMER = 'customer';
export const FORM_NAME_REVIEWBOX = 'reviewbox';
export const FORM_NAME_BOOKAPPOINTMENT = 'bookappointment';
export const FORM_NAME_MANUAL_APPOINTMENT = 'manualappointment';
export const FORM_NAME_WORK_TIME = 'worktimeform';
export const FORM_NAME_SERVICES_TREE = 'servicestree';
export const FORM_NAME_CANCEL_APPOINTMENT = 'cancelappointment';
export const FORM_NAME_RESCHEDULE_APPOINTMENT = 'rescheduleappointment';
export const FORM_NAME_RESCHEDULE_CUSTOM_EVENT = 'reschedulecustomevent';
export const FORM_NAME_ADD_EDIT_SERVICE_GROUP = 'addeditservicegroup';
export const FORM_NAME_SINGLE_ADD_EDIT_SERVICE = 'addeditsingleservice';
export const FORM_NAME_ADD_EDIT_BUNDLE = 'addeditbundle';
export const FORM_NAME_ADD_SERVICES_TO_BUNDLE = 'addservicetobundle';
export const FORM_NAME_NEW_PROMOTION = 'newpromotion';
export const FORM_NAME_NEW_SUBSCRIPTION_PLAN = 'newsubscriptionplan';
export const FORM_NAME_EDIT_SHOP_SUBSCRIPTION_PLAN = 'editshopsubscriptionplan';
export const FORM_NAME_MANUAL_BOOKING_PLAN = 'manualbookingplan';
export const FORM_NAME_BLOCKED_TIME = 'blockedtime';
export const FORM_NAME_SMS_INTERVAL_PICKER = 'smsintervalpicker';

/* sections  form names */
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION1 = 'editmagazinepagesection1';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION2 = 'editmagazinepagesection2';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION3 = 'editmagazinepagesection3';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION4 = 'editmagazinepagesection4';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION5 = 'editmagazinepagesection5';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION6 = 'editmagazinepagesection6';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION7 = 'editmagazinepagesection7';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION8 = 'editmagazinepagesection8';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION9 = 'editmagazinepagesection9';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION10 = 'editmagazinepagesection10';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION11 = 'editmagazinepagesection11';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION12 = 'editmagazinepagesection12';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION13 = 'editmagazinepagesection13';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION14 = 'editmagazinepagesection14';
export const FORM_NAME_EDIT_MAGAZINE_PAGE_SECTION15 = 'editmagazinepagesection15';

/* landing page sections form names */
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION1 = 'editportalpagesection1';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION2 = 'editportalpagesection2';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION3 = 'editportalpagesection3';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION4 = 'editportalpagesection4';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION5 = 'editportalpagesection5';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION6 = 'editportalpagesection6';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION7 = 'editportalpagesection7';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION8 = 'editportalpagesection8';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION9 = 'editportalpagesection9';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION10 = 'editportalpagesection10';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION11 = 'editportalpagesection11';
export const FORM_NAME_EDIT_PORTAL_PAGE_SECTION12 = 'editportalpagesection12';

/* magazine page sections types */
export const MAGAZINE_PAGE_SECTION_TYPE_1 = 'ManageType1';
export const MAGAZINE_PAGE_SECTION_TYPE_2 = 'ManageType2';
export const MAGAZINE_PAGE_SECTION_TYPE_3 = 'ManageType3';
export const MAGAZINE_PAGE_SECTION_TYPE_4 = 'ManageType4';
export const MAGAZINE_PAGE_SECTION_TYPE_5 = 'ManageType5';
export const MAGAZINE_PAGE_SECTION_TYPE_6 = 'ManageType6';
export const MAGAZINE_PAGE_SECTION_TYPE_7 = 'ManageType7';
export const MAGAZINE_PAGE_SECTION_TYPE_8 = 'ManageType8';
export const MAGAZINE_PAGE_SECTION_TYPE_9 = 'ManageType9';
export const MAGAZINE_PAGE_SECTION_TYPE_10 = 'ManageType10';
export const MAGAZINE_PAGE_SECTION_TYPE_11 = 'ManageType11';
export const MAGAZINE_PAGE_SECTION_TYPE_12 = 'ManageType12';
export const MAGAZINE_PAGE_SECTION_TYPE_13 = 'ManageType13';
export const MAGAZINE_PAGE_SECTION_TYPE_14 = 'ManageType14';
export const MAGAZINE_PAGE_SECTION_TYPE_15 = 'ManageType15';

/* landing page sections types */
export const PORTAL_PAGE_SECTION_TYPE_1 = 'PortalPageManageType1';
export const PORTAL_PAGE_SECTION_TYPE_2 = 'PortalPageManageType2';
export const PORTAL_PAGE_SECTION_TYPE_3 = 'PortalPageManageType3';
export const PORTAL_PAGE_SECTION_TYPE_4 = 'PortalPageManageType4';
export const PORTAL_PAGE_SECTION_TYPE_6 = 'PortalPageManageType6';
export const PORTAL_PAGE_SECTION_TYPE_5 = 'PortalPageManageType5';
export const PORTAL_PAGE_SECTION_TYPE_7 = 'PortalPageManageType7';
export const PORTAL_PAGE_SECTION_TYPE_8 = 'PortalPageManageType8';
export const PORTAL_PAGE_SECTION_TYPE_9 = 'PortalPageManageType9';
export const PORTAL_PAGE_SECTION_TYPE_10 = 'PortalPageManageType10';
export const PORTAL_PAGE_SECTION_TYPE_11 = 'PortalPageManageType11';
export const PORTAL_PAGE_SECTION_TYPE_12 = 'PortalPageManageType12';

/* menu types */
export const MENU_TYPE_PAGE = 'MenuTypePage';
export const MENU_TYPE_CATEGORY = 'MenuTypeCategory';
export const MENU_TYPE_MAGAZINE_LINK = 'MenuTypeMagazineLink';
export const MENU_TYPE_PORTAL_LINK = 'MenuTypePortalLink';
export const MENU_TYPE_SHOP = 'MenuTypeShop';

/* landing page sections items */
export const PORTAL_PAGE_SECTION_ITEM_ARTICLE = 'PortalPageSectionItemArticle';
export const PORTAL_PAGE_SECTION_ITEM_PRODUCT = 'PortalPageSectionItemProduct';
export const PORTAL_PAGE_SECTION_ITEM_POLL = 'PortalPageSectionItemPoll';
export const PORTAL_PAGE_SECTION_ITEM_PROFILE = 'PortalPageSectionItemProfile';
export const PORTAL_PAGE_SECTION_ITEM_SHOP = 'PortalPageSectionItemShop';

/* languages */
export const DEFAULT_TRANSLATION_NAMESPACE = 'translation';
export const LANGUAGE_EN_US = 'en-US';
export const LANGUAGE_IT_IT = 'it-IT';
export const LANGUAGE_HR_HR = 'hr-HR';
export const LANGUAGE_SL_SI = 'sl-SI';

/* cookie keys */
export const COOKIE_KEY_LANGUAGE = 'GlossiqLanguage';
export const COOKIE_KEY_LANDING_PAGE_POPUP = 'GlossiqLandingPagePopup';

/* TABS NAMESPACES */
export const USERCARD_TABS_NAMESPACE = 'usercardtabs';
export const SHOPDASHBOARD_PRODUCTTABS_NAMESPACE = 'shopdashboardproductstabs';

/* TABS */
/* user card tabs */
export const USERCARD_TAB_OVERVIEW = 'overview';
export const USERCARD_TAB_WARDROBEITEMS = 'wardrobeitems';
export const USERCARD_TAB_WISHLIST = 'wishlist';
export const USERCARD_TAB_OUTFITS = 'outfits';
export const USERCARD_TAB_ARTICLES = 'articles';
export const USERCARD_TAB_LIKES = 'likes';
export const USERCARD_TAB_ABOUT = 'about';
export const USERCARD_TAB_ACTIVITY = 'activity';
export const USERCARD_TAB_FOLLOWERS = 'followers';
export const USERCARD_TAB_FOLLOWING = 'following';
export const USERCARD_TAB_APPOINTMENTS = 'appointments';
export const USERCARD_TAB_LISTINGS = 'listings';

/* shop card tabs */
export const SHOPCARD_TAB_ANALYTICS = 'analytics';
export const SHOPCARD_TAB_OVERVIEW = 'overview';
export const SHOPCARD_TAB_PRODUCTS = 'products';
export const SHOPCARD_TAB_ARTICLES = 'articles';
export const SHOPCARD_TAB_ABOUT = 'about';
export const SHOPCARD_TAB_POLICIES = 'policies';
export const SHOPCARD_TAB_REVIEWS = 'reviews';
export const SHOPCARD_TAB_SERVICES = 'services';
export const SHOPCARD_TAB_BOOKINGORDER = 'bookingorder';
export const SHOPCARD_TAB_CUSTOMERS = 'customers';
export const SHOPCARD_TAB_CUSTOMERS_ITEMSPERPAGE = 20;
export const SHOPCARD_TAB_ORDERS_ITEMSPERPAGE = 10;

/** search results tabs */
export const SEARCHRESULTS_TAB_USER = 'User';
export const SEARCHRESULTS_TAB_ARTICLE = 'Article';
export const SEARCHRESULTS_TAB_PRODUCT = 'Product';
export const SEARCHRESULTS_TAB_PRODUCT2 = 'Product2';
export const SEARCHRESULTS_TAB_SHOP = 'Shop';

/** products tabs */
export const PRODUCTS_TAB_PRODUCTS = 'products';
export const PRODUCTS_TAB_COLLECTIONS = 'collections';

/** items selector tabs */
export const ITEMS_SELECTOR_TAB_WARDROBE = 'wardrobeitems';
export const ITEMS_SELECTOR_TAB_WISHLIST = 'wishlists';
export const ITEMS_SELECTOR_TAB_PRODUCT = 'products';

/** outfit items tabs */
export const SHOPDASHBOARD_TAB_MOSTSOLD = 'mostsold';
export const SHOPDASHBOARD_TAB_MOSTLIKED = 'mostliked';
export const SHOPDASHBOARD_TAB_MOSTWISHLISTED = 'mostwishlisted';

/** size charts tabs */
export const SIZEGUIDE_TAB_WOMEN = 'sizechartstabwomen';
export const SIZEGUIDE_TAB_MEN = 'sizechartstabmen';
export const SIZEGUIDE_TAB_KIDS = 'sizechartstabkids';

/** reviews */
export const REVIEWS_ITEMSPERPAGE = 15;

/** shipping sizes */
export const SHIPPINGSIZEKEY_S = 1;
export const SHIPPINGSIZEKEY_M = 2;
export const SHIPPINGSIZEKEY_L = 3;

/** shops filter */
export const SHOPS_SEARCH_FILTER = 'searchSalons';
export const SHOPS_LOCATION_FILTER = 'searchLocations';
export const SHOPS_LOCATION_FILTER_LAT = 'searchLocationsLat';
export const SHOPS_LOCATION_FILTER_LNG = 'searchLocationsLng';
export const SHOPS_DATE_FILTER = 'searchDate';
export const SHOPS_HOURS_FILTER = 'searchHours';
export const SHOPS_SORT_FILTER = 'searchSort';
export const SHOPS_CATEGORIES_FILTER = 'searchCategories';

/** services filter */
export const SERVICES_ALL = 'all';
export const SERVICES_WOMAN = 'woman';
export const SERVICES_MAN = 'man';

/** customer filter */
export const CUSTOMER_OVERVIEW = 'overview';
export const CUSTOMER_BIO = 'bio';
export const CUSTOMER_APPOINTMENTS = 'appointments';

/** articles search */
export const ARTICLES_SEARCH_FILTER = 'searchArticles';

/* notifications tabs */
export const NOTIFICATIONS_TAB_USER = 'notificationstabuser';
export const NOTIFICATIONS_TAB_SHOP = 'notificationstabshop';

/** url props */
export const SERVICE_CATEGORY = 'category';
export const SERVICE_GROUP = 'group';
export const SERVICE_NAME = 'name';
export const SERVICE_LAST_ORDER_NUMBER = 'lastOrderNumber';

/** appointment tabs */
export const APPOINTMENT_TAB_ITEMSPERPAGE = 50;

export const ROUTE_USERPROFILECARD = 'profile/';

export const EUROPEAN_UNION_COUNTRY_KEYS = [
	110, 235, 209, 15, 22, 75, 107, 83, 178, 138, 59, 182, 130, 70, 76, 86, 177, 60, 35, 203, 123, 56, 157, 215, 61, 101,
	129, 202,
];
export const WORLDWIDE_OPTION_KEY = 'Worldwide';
export const EUROPEAN_UNION_OPTION_KEY = 'EuropeanUnion';

export const BASE_SERVICE = 'BASE_SERVICE';

export const DEFAULT_CROP_OPTIONS: Partial<ICropperOptions> = {
	cropBoxResizable: false,
	cropBoxMovable: false,
	toggleDragModeOnDblclick: false,
	rotatable: false,
	dragMode: 'move' as const,
	viewMode: 1,
	zoomOnWheel: false,
	zoomOnTouch: false,
};

//make sure the largest size is the first in array
export const DEFAULT_CROP_SIZES_PROFILE_IMAGE = [
	{
		thumbnailPrefix: 'large',
		thumbnailWidth: 712,
		thumbnailHeight: 712,
	},
	{
		thumbnailPrefix: 'medium',
		thumbnailWidth: 280,
		thumbnailHeight: 280,
	},
	{
		thumbnailPrefix: 'small',
		thumbnailWidth: 100,
		thumbnailHeight: 100,
	},
];

export const DEFAULT_CROP_SIZES_USER_BANNER = [
	{
		thumbnailPrefix: 'banner',
		thumbnailWidth: 1920,
		thumbnailHeight: 516,
	},
	{
		thumbnailPrefix: 'thumbnail',
		thumbnailWidth: 756,
		thumbnailHeight: 434,
	},
];

export const DEFAULT_CROP_SIZES_SHOP_BANNER = [
	{
		thumbnailPrefix: 'banner',
		thumbnailWidth: 1920,
		thumbnailHeight: 640,
	},
	{
		thumbnailPrefix: 'thumbnail',
		thumbnailWidth: 756,
		thumbnailHeight: 434,
	},
];

export const DEFAULT_CROP_SIZES_ARTICLE_IMAGE = [
	{
		thumbnailPrefix: '', // only one format for articles for now
		thumbnailWidth: 800,
		thumbnailHeight: 1200,
	},
];

export const ASPECT_RATION_SHOP_PROFILE_PICTURE = 1 / 1;
export const ASPECT_RATION_PROFILE_PICTURE = 1 / 1;
export const ASPECT_RATION_USER_COVER_PICTURE = 1920 / 516;
export const ASPECT_RATION_SHOP_COVER_PICTURE = 1920 / 640;
export const DEFAULT_CROP_NAME = '';
export const DEFAULT_CROP_SIZE = 580;

/* CART WIZARD STEPS */
export const CART_STEP_EMPTY_SHOPPING_BAG = 1;
export const CART_STEP_SHOPPING_BAG = 2;
export const CART_STEP_CHECKOUT_ADDRESS = 3;
export const CART_STEP_CHECKOUT_SHIPPING_OPTIONS = 4;
export const CART_STEP_CHECKOUT_PAYMENT = 5;

// /* CATEGORIES */
// export const WOMEN_CATEGORY_KEY: number = 1;
// export const MEN_CATEGORY_KEY: number = 2;
// export const WOMEN_SHOES_CATEGORY_KEY: number = 60;
// export const MEN_SHOES_CATEGORY_KEY: number = 134;
// export const WOMEN_ACTIVEWEAR_CATEGORY_KEY: number = 4;
// export const MEN_SHIRTS_CATEGORY_KEY: number = 100;
// export const MEN_PANTS_CATEGORY_KEY: number = 117;

export const SOME_CATEGORY_KEYS = {
	HAIRBEARD: 1,
	HAIRBEARD_HAIR: 2,
	SKINCARE: 69, //nice
	SKINCARE_MOISTURIZERS: 70,
	SKINCARE_CLEANSERS: 75,
	SKINCARE_MASKS: 81,
	SKINCARE_SUNSCREEN: 85,
	MAKEUP: 24,
	MAKEUP_FACE: 25,
	MAKEUP_EYES: 35,
	MAKEUP_LIP: 45,
	MAKEUP_NAILS: 53,
	FRAGRANCE: 57,
	TOOLS: 90,
	NUTRITION: 113,
	PET_BEAUTY: 152,
};

// every element MUST me 'as const' in order for AttributeName to be a string literal
export const ATTRIBUTES_KEYS = {
	HAIR_TREATMENTS: 'HairTreatment' as const,
	HAIR_TYPE: 'HairType' as const,
	HAIR_LENGTH: 'HairLength' as const,
	SKIN_TREATMENTS: 'SkinTreatment' as const,
	COLOUR: 'Colour' as const,
	COLOUR_NAME: 'ColourName' as const,
	FLAVOUR: 'Flavour' as const,
	FLAVOUR_NAME: 'FlavourName' as const,
};

export type AttributeName = (typeof ATTRIBUTES_KEYS)[keyof typeof ATTRIBUTES_KEYS];

export const RESTRICTED_MODE = 'rm';
